// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-main[data-v-41c51cd0]{padding:0;margin:0;overflow:hidden;background-color:#2c3e50}.el-main svg[data-v-41c51cd0]{height:auto;width:100%}", ""]);
// Exports
module.exports = exports;
